// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
Bao.Templates.permissionTree = "<ul data-bind=\"foreach: Nodes\"><li data-bind='visible: $parent.Expanded'><i class=\"fa\" data-bind=\"click: $root.ToggleNode, css: Icon, visible: Icon() != ''\"></i>         <input class=\"checkbox-inline\" type=\"checkbox\" data-bind=\"click: $root.FormPermissionClicked, checked: Checked, visible: CheckBoxVisible\" />        <span data-bind=\"css: {selected: $root.SelectedNode() == $data}\"><a data-bind=\"click: $root.NodeClick\"><span data-bind=\"text: Text\"></span><span class=\"badge synoset\" data-bind=\"visible: CountVisible, text: Count\"></span></a></span><!-- ko template: 'permissionTree' --><!-- /ko -->    </li></ul>";
ko.bindingHandlers.permissionTree = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        $(element).addClass("permissionTree");
        var permissionTreeVM = function () {
            var self = this;
            self.ToggleNode = function (node) {
                node.Expanded(!node.Expanded());
                if (valueAccessor().NodeToggled != undefined) {
                    valueAccessor().NodeToggled(node);
                }
            };
            self.NodeClick = function (node) {
                self.SelectedNode(node);
            };
            self.FormPermissionClicked = function (node, e) {
                self.ClickedNode(node);
                return true;
            };
            self.Expanded = ko.observable(true);            
        };
        var newContext = ko.utils.extend(new permissionTreeVM(), valueAccessor());
        $(element).html(Bao.Templates.permissionTree);
        ko.applyBindingsToDescendants(newContext, element);
        return {
            controlsDescendantBindings: true
        };
    }
};